<div class="error-state text-center py-5 px-3" role="alert">
  <i class="fa fa-exclamation-triangle error-state__icon" aria-hidden="true"></i>
  <h5 class="error-state__title mt-3 mb-1">{{ titleKey | translate }}</h5>
  <p class="error-state__message text-muted mb-0">{{ messageKey | translate }}</p>

  @if (detail) {
    <p class="error-state__detail small text-muted mt-2 mb-0">{{ detail }}</p>
  }

  @if (retryable) {
    <button type="button" class="btn btn-outline-primary mt-3" (click)="retry.emit()">
      <i class="fa fa-refresh me-1" aria-hidden="true"></i>
      {{ 'COMMON.RETRY' | translate }}
    </button>
  }
</div>
